module.exports = __webpack_public_path__ + "media/img/masks/avatar-group-hover-last-6ac726130dcb2db3245cbd2b42a47685.svg";